module.exports = __webpack_public_path__ + "resources/img/img_prodiscovery1_m.2f2db9941d10b0ac35c4b50e9714a4b4.png";